import { AppFunctionComponent } from "../../types"
import React from "react"
import styled from "styled-components"
import DownloadButton from "../../components/common/download-button/download-button.component"
import { DownloadButtonProps as Props } from "../../components/common/download-button/download-button.interface"
import LinuxIcon from "../../images/icons/download-button/linux.inline.svg"
import MacOsIcon from "../../images/icons/download-button/mac-os.inline.svg"
import WindowsIcon from "../../images/icons/download-button/windows-icon.inline.svg"
import { DownloadButton as DownloadButtonProps } from "../../types"
import { TextLink } from "../../ui/components/link/link.component"
import RichText from "../rich-text/rich-text.resolver"

const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 296px;
  margin-top: 2em;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    margin: auto;
  }
`

const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 30px;
  margin-top: 15px;

  > * {
    margin: 0 5px;

    &:last-child {
      margin-right: 0px;
    }

    &:first-child {
      margin-left: 0px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
      margin: 0 auto;
    }
  }
`

const EmbedWrapper = styled.div`
  margin: 0;
  padding: 30px;
  min-height: 386px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.color.backgroundAttentionLight};

  p {
    font-size: ${14 / 16}rem;
  }
`

const DownloadButtonWrapper = styled.div`
  margin: auto 0;
`

export const DownloadButtonResolver: AppFunctionComponent<Props> = ({
  macUrl,
  windowsUrl,
  linuxUrl,
  googlePlayUrl,
  appStoreUrl,
  className,
}) => {
  return (
    <DownloadWrapper>
      <DownloadButton
        macUrl={macUrl}
        windowsUrl={windowsUrl}
        linuxUrl={linuxUrl}
        googlePlayUrl={googlePlayUrl}
        appStoreUrl={appStoreUrl}
        className={className}
      />
      <LinksWrapper>
        <WindowsIcon aria-hidden="true" />
        <TextLink to={windowsUrl}>Windows</TextLink>
        <MacOsIcon aria-hidden="true" />
        <TextLink to={macUrl}>Mac Os</TextLink>
        {linuxUrl && (
          <>
            <LinuxIcon aria-hidden="true" />
            <TextLink to={linuxUrl}>Linux</TextLink>
          </>
        )}
      </LinksWrapper>
    </DownloadWrapper>
  )
}

export const EmbedDownloadButtonResolver: AppFunctionComponent<
  DownloadButtonProps
> = ({
  macUrl,
  windowsUrl,
  linuxUrl,
  googlePlayUrl,
  appStoreUrl,
  className,
  contentText,
}) => {
  return (
    <EmbedWrapper>
      <DownloadButtonWrapper>
        <DownloadButtonResolver
          macUrl={macUrl}
          windowsUrl={windowsUrl}
          linuxUrl={linuxUrl}
          googlePlayUrl={googlePlayUrl}
          appStoreUrl={appStoreUrl}
          className={className}
        />
      </DownloadButtonWrapper>
      {contentText && <RichText content={contentText} />}
    </EmbedWrapper>
  )
}
